import PropTypes from 'prop-types';
import React from 'react';

function AppPreloader(props) {

    return (
        <div className="app-preloader">
            <div className="app-preloader__spinner"></div>
            <h1>{props.label}</h1>
        </div>
    );

}

AppPreloader.propTypes = {
    label: PropTypes.string.isRequired
};

export default AppPreloader



/** WEBPACK FOOTER **
 ** ./src/components/AppPreloader.js
 **/